const vipAttrProps = {
  本月新增会员: "newMembers",
  本月会员新增目标: "newTarget",
  新增会员月目标完成率: "targetRate",
  本月新增环比: "hb",
  本月新增同比: "tb",
  本月渠道拓展业绩: "tzyj",
  本月异业业绩目标: "yjmb",
  渠道推进人数: "tjrs",
  渠道推进人数环比: "tjhb",
  渠道推出人数: "tcrs",
  渠道推出人数环比: "tchb",
};

export default vipAttrProps;
